import { matchesRoute } from 'features/tours/tours'
import { routePath } from 'features/tours/workflowRunner'

const stripQuery = value => String(value || '').split('?')[0]

export const suggestGuides = (workflows, pathname, { completed = () => false, isAvailable = () => true, limit = 3 } = {}) => {
  const path = stripQuery(pathname)
  return workflows.filter(workflow => {
    const route = workflow.steps?.[0]?.route
    if (!route) return false
    if (!matchesRoute(stripQuery(routePath(route)), path)) return false
    if (completed(workflow)) return false
    if (!isAvailable(workflow)) return false
    return true
  }).slice(0, limit)
}
